import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circled-check",
  "use": "circled-check-usage",
  "viewBox": "0 0 15 14",
  "content": "<symbol viewBox=\"0 0 15 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"circled-check\">\n<path d=\"M5 7.3125L6.875 9.1875L10 5.4375\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M7.5 13.25C10.9518 13.25 13.75 10.4518 13.75 7C13.75 3.54822 10.9518 0.75 7.5 0.75C4.04822 0.75 1.25 3.54822 1.25 7C1.25 10.4518 4.04822 13.25 7.5 13.25Z\" stroke=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol